module.exports = __webpack_public_path__ + "static/bh-7e7cb661ce72b978d4d6909005555518.png";